import React, { useState, useMemo, useCallback, useEffect } from 'react';
// 1. react-router-dom에서 Link 컴포넌트를 가져옵니다.
import { Link, Navigate } from 'react-router-dom';
import {useAuth} from '../context/AuthContext'
import AdComponent from './ads/AdComponent';
import { DataListResponse } from '@playball/common/dto/Common';
import { KBOPlayerYearStatsListItemDto } from '@playball/common/dto/KBO';



interface PlayerListProp {
  draftPlayerList: KBOPlayerYearStatsListItemDto[];
}
type GroupedPlayers = Record<string, Record<string, KBOPlayerYearStatsListItemDto[]>>;

const TEAM_NAME_MAP: { [key: string] :string } = {
  'LG': '트윈스', 'SSG': '랜더스', 'KT': '위즈', 'NC': '다이노스', 'KIA': '타이거즈',
  '롯데': '자이언츠', '두산': '베어스', '삼성': '라이온즈', '한화': '이글스', '키움': '히어로즈'
}
// --- 메인 컴포넌트 ---
const PlayerList: React.FC<PlayerListProp> = ({ draftPlayerList }) => {
  const [selectedPosition, setSelectedPosition] = useState<string | null>(null);
  const [selectedTeam, setSelectedTeam] = useState<string | null>(null);
  const allPositions = ['P','1B', '2B', '3B', 'SS','C', 'CF',  'LF', 'RF', 'DH']
  const POSITION_MAP: {[key: string]: string} = {'P': '투수', '1B': '1루수','2B': '2루수','3B': '3루수','SS': '유격수',
                    'C': '포수','CF': '중견수','DH': '지명타자', 'LF': '좌익수','RF': '우익수',}
  

  const allTeams = Object.values(TEAM_NAME_MAP)   
  const filteredPlayers = useMemo(() => {
    let filtered = [...draftPlayerList]

    if (selectedPosition){
        filtered = filtered.filter(player => player.position === selectedPosition)
    }

    if (selectedTeam){
        filtered = filtered.filter(player=> player.team === selectedTeam || TEAM_NAME_MAP[player.team] === selectedTeam)
    }

    return filtered;
  }, [draftPlayerList, selectedPosition, selectedTeam]);

  const groupedByTeamAndPosition = useMemo<GroupedPlayers>(() => {
    return filteredPlayers.reduce<GroupedPlayers>((acc, player) => {
      const { team, position } = player;
      if (!acc[team]) acc[team] = {};
      if (!acc[team][position]) acc[team][position] = [];
      acc[team][position].push(player);
      return acc;
    }, {});
  }, [filteredPlayers]);




  return (
    <>
    <section className="guide-hero-section py-5">
      <div className="container text-center">
        <h1 className="display-5 fw-bold">KBO 드래프트 선수 명단</h1>
      </div>
    </section>

    <div style={styles.container}>
      <div style={styles.filterVerticalContainer}>

      {/* 포지션 필터 버튼 UI */}
        <div style={styles.filterContainer}>
            <button
            style={!selectedPosition ? { ...styles.filterButton, ...styles.activeFilter } : styles.filterButton}
            onClick={() => setSelectedPosition(null)}
            className="filter-button" // 호버 효과를 위한 클래스명 추가
            >
            전체
            </button>
            {allPositions.map(pos => (
            <button
                key={pos}
                style={selectedPosition === pos ? { ...styles.filterButton, ...styles.activeFilter } : styles.filterButton}
                onClick={() => setSelectedPosition(pos)}
                className="filter-button" // 호버 효과를 위한 클래스명 추가
            >
                {POSITION_MAP[pos]}
            </button>
            ))}
        </div>
        <div style={styles.filterContainer}>
            <button
            style={!selectedTeam ? { ...styles.filterButton, ...styles.activeFilter } : styles.filterButton}
            onClick={() => setSelectedTeam(null)}
            className="filter-button" // 호버 효과를 위한 클래스명 추가
            >
            전체
            </button>
            {allTeams.map(team => (
            <button
                key={team}
                style={selectedTeam === team ? { ...styles.filterButton, ...styles.activeFilter } : styles.filterButton}
                onClick={() => setSelectedTeam(team)}
                className="filter-button" // 호버 효과를 위한 클래스명 추가
            >
                {team}
            </button>
            ))}
        </div>
      </div>

      {/* 선수 명단 렌더링 */}
      {Object.keys(groupedByTeamAndPosition).map(teamName => (
        <div key={teamName} style={styles.teamSection}>
          <h2 style={styles.teamTitle}> {TEAM_NAME_MAP[teamName]}</h2>
          {Object.keys(groupedByTeamAndPosition[teamName]).map((position, index) => (
            <>
              <div key={position} style={{ marginBottom: '1rem' }}>
                <h3 style={styles.positionTitle}>포지션: {POSITION_MAP[position]}</h3>
                <div style={styles.tableWrapper}>
                  <table style={styles.table}>
                    <thead style={styles.tableHead}>
                      <tr>
                        <th style={{ ...styles.tableHeader, width: '70%' }}>이름</th>
                        <th style={styles.tableHeader}>포지션</th>
                      </tr>
                    </thead>
                    <tbody>
                      {groupedByTeamAndPosition[teamName][position].map((player) => (
                        <tr key={player.player_id} className="table-row">
                          {/* 2. 기존 player.name을 <Link> 컴포넌트로 감싸줍니다. */}
                          <td style={styles.tableCell}>
                            {/* 각 선수의 id를 사용하여 동적 URL을 생성합니다. */}
                            <Link to={`/player/${player.player_id}`} style={styles.playerLink}>
                              {player.name}
                            </Link>
                          </td>
                          <td style={styles.tableCell}>{POSITION_MAP[player.position]}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              { index > 0 && index % 3 === 0 && <AdComponent adSlot="list" /> }
            </>
          ))}
        </div>
      ))}
      {/* CSS-in-JS로 호버 효과 추가 */}
      <style>{`
        .table-row:hover {
          background-color: #f5faff;
        }
        .filter-button:hover {
            background-color: #e9ecef;
        }
        /* 3. Link 태그에 대한 호버 효과를 추가합니다. */
        .player-link:hover {
            text-decoration: underline;
        }
      `}</style>
    </div>
    </>
  );
};

// --- 스타일 객체 ---
const styles: { [key: string]: React.CSSProperties } = {
  container: {
    fontFamily: "'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif",
    color: '#333',
    padding: '20px',
    maxWidth: '900px',
    margin: 'auto',
  },
  mainTitle: {
    fontSize: '1.8rem',
    color: '#1a3a6e',
    textAlign: 'center',
    marginBottom: '20px',
  },
  filterVerticalContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '8px',
    marginBottom: '30px',
  },

  filterContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '8px',
    marginBottom: '30px',
  },
  filterButton: {
    padding: '6px 14px',
    fontSize: '0.85rem',
    border: '1px solid #ccc',
    borderRadius: '16px',
    backgroundColor: '#f9f9f9',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  },
  activeFilter: {
    backgroundColor: '#005a9c',
    color: 'white',
    border: '1px solid #005a9c',
    fontWeight: 'bold',
  },
  teamSection: {
    marginBottom: '30px',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    padding: '12px 20px',
    backgroundColor: '#fff',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
  },
  teamTitle: {
    fontSize: '1.4rem',
    borderBottom: '2px solid #1a3a6e',
    paddingBottom: '8px',
    color: '#1a3a6e',
  },
  positionTitle: {
    fontSize: '1rem',
    color: '#444',
    fontWeight: 600,
    marginTop: '1.2rem',
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '0.9rem',
  },
  tableHead: {
    backgroundColor: '#f7f8fa',
  },
  tableHeader: {
    padding: '8px 12px',
    fontWeight: 600,
    textAlign: 'left',
    color: '#333',
  },
  tableCell: {
    padding: '8px 12px',
    borderTop: '1px solid #f0f0f0',
    textAlign: 'left',
  },
  // 4. Link 태그에 적용할 기본 스타일을 추가합니다.
  playerLink: {
      color: '#005a9c',
      textDecoration: 'none',
      fontWeight: 500,
  }
};


const PlayerListComponent = () => {
    const { fetchApi } = useAuth();
    const [playerDataList, setPlayerData] = useState<KBOPlayerYearStatsListItemDto[] | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const fetchPlayerList = useCallback(async () => {
          
          setIsLoading(true);
          setError(null);
          try {
              const data: DataListResponse<KBOPlayerYearStatsListItemDto> = await fetchApi(`/api/player`);
              setPlayerData(data.dataList);
          } catch (err: any) {
              setError(err.message || '라인업 정보를 불러오는 데 실패했습니다.');
          } finally {
              setIsLoading(false);
          }
      }, [fetchApi]);
  
      useEffect(() => {
          fetchPlayerList();
      }, [fetchPlayerList]);

  
    if (isLoading) {
        return <div className="container mt-5 text-center"><h2> 리그 정보 로딩 중...</h2></div>;
    }

    if (error) {
        // 에러 발생 시, 에러 메시지를 보여주고 홈페이지로 리다이렉트할 수 있습니다.
        alert(error);
        return <Navigate to="/" replace />;
    }

    if (!playerDataList || playerDataList.length === 0){
        return <div className="container mt-5 text-center"><h2>선수 로드 실패</h2></div>;
    }

  return <PlayerList draftPlayerList={playerDataList} />;
};

export default PlayerListComponent;